<template>
  <div
    class="z-10 fixed p-2 text-sm text-red-600 bottom-0 left-0"
  >
    {{ appConfig.version }}
  </div>
  <router-view />
  <NotificationWrapper class="z-30" />
  <ServiceWorkerWatch />
</template>


<script setup lang="ts">

import {
  computed,
  onMounted,
} from 'vue';
import ServiceWorkerWatch from '@/modules/Core/components/ServiceWorkerWatch.vue';
import NotificationWrapper from '@/modules/Notification/components/NotificationWrapper.vue';
import {useConfigStore} from '@/stores/config';
import {usePhotoStore} from '@/stores/photos';

const appConfig = computed(() => APP_CONFIG);
const configStore = useConfigStore();
const photoStore = usePhotoStore();

onMounted(async () => {
  await configStore.load();
  await photoStore.fetchSessions();
});

</script>
